import React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { useQuery } from "@apollo/client/react";

import { ASSET_VARIANTS_QUERY } from "../../../constants/graphql/queries";
import AssetCard from "./AssetCard";
import SkeletonResult from "./SkeletonResult";
import { useCustomFields } from "../../../contexts/customFields";

export default function KitVariantsModal({ asset, onClose, defaultValues, processNewItem }) {
  const { data, loading } = useQuery(ASSET_VARIANTS_QUERY, {
    skip: !asset?.id,
    variables: { id: asset?.id },
    fetchPolicy: "network-only",
  });
  const [display] = useCustomFields();
  const variants = data?.asset?.variants || [];

  return (
    <Dialog fullWidth maxWidth="lg" open onClose={onClose}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={2}
        pt={1}
        position="relative"
      >
        <DialogTitle sx={{ p: 0 }}>
          <Typography fontSize={20} align="center" fontWeight={500} color="textPrimary">
            Kit Variants
          </Typography>
        </DialogTitle>
        <IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        {loading ? (
          <SkeletonResult />
        ) : variants.length === 0 ? (
          <Typography color="textSecondary">No variants available.</Typography>
        ) : (
          <Grid container spacing={2}>
            {variants.map(variant => (
              <Grid key={`VariantCard${variant.id}`} size={{ md: 4, sm: 6, xs: 12 }}>
                <AssetCard
                  asset={variant}
                  display={display}
                  defaultValues={defaultValues}
                  processNewItem={processNewItem}
                  onSuccess={onClose}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
}
